import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-discount-proposal',
  templateUrl: './discount-proposal.component.html',
  styleUrls: ['./discount-proposal.component.css']
})
export class DiscountProposalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/platform/customer/discount-proposal/discount-proposal.component.ts